
export const getColorOrGradient = (colors: { backgroundStart?: string, backgroundEnd?: string, background?: string }) => {
  return colors.backgroundStart && colors.backgroundEnd
    ? {
      start: colors.backgroundStart,
      end: colors.backgroundEnd,
    }
    : colors.background!;
};
